export const getFilteredRoomsWithSamePrice = (
    rooms: Record<string, any[]>,
    flightRoom: any
  ): { flatResult: any[]; isPriceSame: boolean } => {
    let filterRoom: any[] = [];
  
    // Step 1: Filter rooms with matching room_name
    Object.values(rooms).forEach((roomList: any[]) => {
      const filteredItems = roomList?.filter((roomItem: any) => {
        return flightRoom?.multiRooms?.some(
          (multiItem: any) =>
            multiItem?.room_name?.toLowerCase() === roomItem?.room_name?.toLowerCase()
        );
      });
      filterRoom?.push(filteredItems);
    });
  
    // Step 2: Filter rooms with matching meal_name
    const mealNameFilter = filterRoom?.map((roomList) => {
      return roomList?.filter((roomItem: any) => {
        return flightRoom?.multiRooms?.some(
          (multiItem: any) =>
            multiItem?.meal_name?.toLowerCase() === roomItem?.meal_name?.toLowerCase()
        );
      });
    });
  
    // Step 3: For each meal, pick room with lowest total_package
    const result = mealNameFilter?.map((mealGroup) => {
      return Object.values(
        mealGroup?.reduce((acc: any, item: any) => {
          const meal = item?.meal_name?.toLowerCase();
          if (!acc[meal]) {
            acc[meal] = item;
          } else if (
            parseFloat(item?.total_package) < parseFloat(acc[meal]?.total_package)
          ) {
            acc[meal] = item;
          }
          return acc;
        }, {})
      );
    });
  
    const flatResult = result.flat();
  
    // Step 4: Compare prices with flightRoom.multiRooms
    const isPriceSame =
      flatResult?.length > 0 &&
      flatResult?.every((item: any, index) => {
        return (
          item?.total_package ===
          flightRoom?.multiRooms?.[index]?.total_package
        );
      });
  
    return { flatResult, isPriceSame };
  };
  